import { type Error, type RawError } from 'src/utils/datadog/types';

export function createErrorFieldFromRawError(
  rawError?: RawError
): Error | null {
  if (!rawError) return null;

  return {
    stack: rawError.stack,
    kind: rawError.type,
    message: rawError.message,
  };
}
